import request from '@/request'

export async function getSubscription () {
  const response = await request({
    url: '/users/me/subscriptions',
    method: 'get',
  })

  return response.data
}

export async function requestSubscriptionCancellation (feedback, reasons) {
  const response = await request({
    url: '/v2/users/me/subscription/cancel',
    method: 'post',
    data: {
      feedback,
      reason: reasons,
    }
  })

  return response.data
}
